import { render, staticRenderFns } from "./VisitShortMg.vue?vue&type=template&id=b3bd9e98&scoped=true"
import script from "./VisitShortMg.vue?vue&type=script&lang=js"
export * from "./VisitShortMg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd9e98",
  null
  
)

export default component.exports